export const ROUTES = {
  TRADE: '/trade',
  PORTFOLIO: '/portfolio',
  MARKETS: '/markets',
  VEST_CAPITAL: '/vest-capital',
  ACCOUNTS: '/accounts',
  TERMS: '/terms',
  PROP_TERMS: '/prop-terms',
  PRIVACY: '/privacy',
  OAUTH_REDIRECT: '/oauth/redirect',
  JOIN: '/join',
  CUSTOM_NETWORK_WITHDRAW: '/custom-network-withdraw',
  LIQUIDITY_PROVIDING: '/liquidity-providing',
  REFERRALS: '/referrals',
  POINTS: '/points',
  AFFILIATES: '/affiliates',
  AFFILIATES_INVITE: '/affiliates/invite',
  PAYMENT_SUCCESS: '/payment/success',
  PAYMENT_CANCELLED: '/payment/cancelled',
  DEPOSIT: '/deposit',
  DEPOSIT_GET_FUNDED: '/deposit/get-funded',
  DEPOSIT_ONRAMPER: '/deposit/onramper',
} as const;

export type RouteKey = keyof typeof ROUTES;

export const DEFAULT_MARKET = 'NVDA-USD-PERP';

export function getDefaultMarket() {
  return localStorage.getItem('last-market') || DEFAULT_MARKET;
}
